export default "__VITE_ASSET__f77bf0b4__"